var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 163.24 230.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        opacity: .5;\r\n        stroke: url(#Degradado_sin_nombre_58);\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: .68px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #ebebeb;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #110bff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58",
    "data-name": "Degradado sin nombre 58",
    x1: 81.28,
    y1: 137.63,
    x2: 148.71,
    y2: 137.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "14.86 211.9 0 45.28 163.24 45.28 148.37 211.88 81.52 230.41 14.86 211.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m81.62,216.24l54.02-14.97,12.71-142.36h-66.72v157.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.62,120.7h-27.04l-1.87-20.93h28.91v-20.44H30.38l.49,5.48,5.02,56.32h45.73v-20.44Zm0,53.07l-.09.02-22.76-6.15-1.45-16.3h-20.51l2.86,32.09,41.86,11.62.09-.03v-21.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m15.19,0h10.39v10.26h9.5V0h10.39v31.07h-10.39v-10.4h-9.5v10.4h-10.38V0h0Zm43.93,10.3h-9.14V0h28.68v10.3h-9.15v20.77h-10.39V10.3ZM83.2,0h10.83l6.66,10.92,6.65-10.92h10.83v31.07h-10.34v-15.4l-7.14,11.05h-.18l-7.15-11.05v15.4h-10.16V0h0Zm40.15,0h10.39v20.8h14.6v10.27h-24.99V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.55,120.7v20.44h25.16l-2.37,26.5-22.79,6.15v21.26l41.89-11.61.31-3.45,4.8-53.8.5-5.49h-47.5Zm0-41.36v20.44h49.36l.41-4.59.93-10.36.49-5.48h-51.19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.078bd956120368a3036243c071e04ff4.svg";
export { ForwardRef as ReactComponent };